import Divcontainer from '../components/atoms/Divcontainer/Divcontainer';
import { useNavigate } from 'react-router-dom';
import Button from '../components/atoms/Button/Button';

const Preamble = () => {
  const navigate = useNavigate();

  const startRegistration = () => {
    navigate('/register');
  };
  return (
    <div>
      <Divcontainer>
        <p className='pb-5 font-bold'>
          Registration for catechism at OLPS will take place in the following
          phases:
        </p>
        <p>
          <span className='font-bold'>Phase 1 (10–16 October):</span> Siblings
          of existing students enrolled in Levels 1 to 10 in 2026
        </p>
        <p>
          <span className='font-bold'>Phase 2 (17–23 October):</span>{' '}
          Parishioners living within the OLPS parish boundary (
          <a
            href='https://www.streetdirectory.com/Parish-Map/'
            target='_new'
            className='font-bold'
          >
            Please enter your postal code here to check.
          </a>
          )
        </p>
        <p>
          <span className='font-bold'>Phase 3 (24 October–6 November):</span>{' '}
          All other Level 1 applicants and transfers from other parishes for
          other catechism levels
        </p>
      </Divcontainer>

      <Divcontainer>
        <span className=' font-bold'>
          REGISTRATION AND TRANSFER FOR ALL LEVELS FOR 2027 CLOSES 6 NOVEMBER
          2026.
        </span>
      </Divcontainer>

      <Divcontainer>
        <p className=' font-bold'>Important Administrative Notes </p>
        <ul className='list-inside list-disc'>
          <li>
            You can register multiple children from the same household in a
            single registration. Simply click on Add Another Child at the bottom
            of the page after entering your first child's details.
          </li>
          <li>
            All your children are linked to your parent account. You may access
            it at cats.olps.sg via Upload Documents, using your registered email
            address.
          </li>
          <li>All registrations must be completed online.</li>
          <li>
            Please note that catechism received in schools does not constitute
            formal parish catechesis. Formal catechesis begins from Level 1 in
            the parish, starting in the year your child turns 7.
          </li>
        </ul>
      </Divcontainer>

      <Divcontainer>
        <p className='font-bold'>Documents Required</p>
        <p>
          For your registration to be considered complete, please upload the
          following documents where applicable:
        </p>
        <ol className='list-inside list-decimal'>
          <li>Child's Baptism Certificate</li>
          <li>Child's First Reconciliation Certificate</li>
          <li>Child's First Holy Communion Certificate</li>
          <li>Transfer Letter from the current parish</li>
        </ol>

        <p className='pb-3 pt-3'>
          Please scan all documents using a phone scanner or desktop scanner.
          <ul className='list-inside list-disc'>
            <li>Maximum document size: 5 MB</li>
            <li>Accepted formats: PDF, JPG</li>
          </ul>
        </p>
      </Divcontainer>

      <Divcontainer>
        <p className='font-bold'>Catechism for Unbaptised Children</p>
        <p>
          Unbaptised children may enrol for catechism at OLPS at the ages of 7
          (Level 1) or 8 (Level 2), provided there is an intention for them to
          receive the Sacrament of Baptism. This Sacrament can only be conferred
          after{' '}
          <span className='font-bold'>
            one year of formation through catechetical sessions.
          </span>
        </p>
      </Divcontainer>

      <Divcontainer>
        <p className='font-bold'>Annual Materials Fee</p>
        <p>
          There will be a collection of materials fee of{' '}
          <span className='font-bold'>$35</span> per student. Payment is to be
          made via PayNow only. The UEN details will be sent to your registered
          email address upon confirmation of enrolment.. Once payment has been
          made, an email acknowledgement will be sent to confirm receipt of the
          fee.
        </p>
      </Divcontainer>

      <Divcontainer>
        <p className='font-bold'>Enrolment Update</p>
        <p>
          All parents will be notified by email of their child's enrolment
          status after registration closes on 6 November 2026.
        </p>
      </Divcontainer>

      <Divcontainer>
        <p className='font-bold'>Bridging Programme</p>
        <p>
          If your child is aged 9 and above in 2027, and has never received
          formal catechesis, we strongly encourage that you consider signing
          him/her up for the Bridging Programme conducted by the Office for
          Catechesis (OFC). This programme is suitable for children/youth aged{' '}
          <span className='font-bold'>9 to 13</span> who:
        </p>
        <ul className='list-inside list-disc'>
          <li>have never had formal catechesis and wish to start;</li>
          <li>
            have missed formal catechesis for a prolonged period and wish to
            rejoin;
          </li>
          <li>
            are relocating to Singapore with no or little formal catechesis;
          </li>
          <li>
            are unbaptised and wish to be baptised and will join parish
            catechesis thereafter.
          </li>
        </ul>
        <p>
          Through this programme, OFC will prepare and support children/youth in
          joining their peers for catechism at the parish. OLPS is one of four
          locations that hosts these bridging sessions. Please contact OFC
          directly to check if places are still available.
        </p>
      </Divcontainer>

      <Divcontainer>
        For more information on the Bridging Programme, please{' '}
        <a
          href='https://www.catechesis.org.sg/Programmes/Bridging-Programme'
          target='_blank'
          rel='noopener noreferrer'
          className='font-bold text-primary-500'
        >
          click here
        </a>{' '}
        here. Do note that your child's place at OLPS after completing the
        one-year Bridging Programme is not secured until registration at OLPS
        has been completed.
      </Divcontainer>

      <Divcontainer>
        If you have any questions about the registration process for catechism,
        please do not hesitate to reach out to us:
        <br />
        <a
          href='mailto:catechists@olps.sg'
          className='font-bold text-primary-500'
        >
          Email
        </a>{' '}
        | <span className='font-bold text-primary-500'>Phone:</span> 6241 8047 |{' '}
        <a
          href='https://wa.me/message/LMY4KP44NTK6C1'
          className='font-bold text-primary-500'
        >
          Whatsapp
        </a>
      </Divcontainer>

      <div className='py-8 text-center'>
        <Button callback={startRegistration} testid='start-registration-button'>
          Start Registration
        </Button>
      </div>
    </div>
  );
};

export default Preamble;
